{
  "ddd, MMM D, YYYY": "ddd D MMM YYYY",
  "h:mm A z": "HH:mm z",
  "Video fragment {number}": "Videofragment {number}",
  "Upload to Beginning": "Uploaden aan het begin",
  "Upload to End": "Uploaden aan het eind",
  "Replace All Video": "Hele video vervangen",
  "Total length: {duration}": "Totale lengte: {duration}",
  "Upload After": "Hierna uploaden",
  "Delete this uploaded video?": "Deze geüploade video verwijderen?",
  "Delete this video fragment?": "Dit videofragment verwijderen?",
  "Video fragment deleted": "Videofragment verwijderd",
  "Could not delete video fragment": "Het videofragment kon niet worden verwijderd",
  "Loading event video...": "Video van het evenement laden...",
  "Deleting video fragment...": "Videofragment verwijderen...",
  "Loading uploaded video fragments...": "Geüploade videofragmenten laden...",
  "Could not finish upload": "De upload kon niet worden voltooid",
  "Could not queue video conversion": "De videoconversie kon niet in de wachtrij worden gezet",
  "Event video is uploaded and will be processed now": "De video van het evenement is geüpload en wordt nu verwerkt",
  "Upload an edited or backup recording of the live stream. This will replace the current video on event page.": "Upload een bewerkte opname of een reserveopname van de livestream. Die vervangt de huidige video op de evenementpagina.",
  "Upload video to event page. Video will show on event page before Live Stream starts. Once you go Live, the live stream will replace the uploaded video automatically": "Upload een video naar de evenementpagina. De video is op de evenementpagina te zien voordat de livestream begint. Zodra je live gaat, vervangt de livestream de geüploade video automatisch",
  "Delete Uploaded Video?": "Geüploade video verwijderen?",
  "Notify all guests when it's uploaded": "Alle gasten laten weten wanneer de video is geüpload",
  "Permission to Access Photo Library Necessary": "Toegang tot je foto's nodig",
  "Could not access selected video.": "Geen toegang tot de gekozen video.",
  "Could not open the video.": "De video kon niet worden geopend.",
  "This video may still be in iCloud. Open Photos, download it to this iPhone, and try again.": "Deze video staat misschien nog in iCloud. Open Foto's, download hem naar deze iPhone en probeer het opnieuw.",
  "Please try again, or choose another video.": "Probeer het opnieuw of kies een andere video.",
  "Could not open video library.": "De videobibliotheek kon niet worden geopend.",
  "Please check if permissions are given": "Controleer of de app toegang heeft",
  "Could not start video upload.": "Het uploaden van de video kon niet starten.",
  "Please try another video or check photo permissions in iOS Settings.": "Probeer een andere video of controleer de toegang tot foto's in de instellingen van iOS.",
  "Only mov or mp4 files are accepted": "Alleen mov- of mp4-bestanden worden geaccepteerd",
  "Cancel this upload?": "Deze upload annuleren?",
  "The part already uploaded will be discarded.": "Het deel dat al is geüpload, wordt weggegooid.",
  "Cancel upload": "Upload annuleren",
  "Keep uploading": "Doorgaan met uploaden",
  "{loaded} from {total}": "{loaded} van {total}",
  "Uploading...": "Uploaden...",
  "Video Uploaded": "Video geüpload",
  "Converting Video. This may take a few minutes.": "Video wordt geconverteerd. Dit kan een paar minuten duren.",
  "Replace live video": "Livevideo vervangen",
  "MOV or MP4 video. 10GB Max.": "MOV- of MP4-video. Max. 10 GB.",
  "Failed to start upload": "Upload kon niet starten",
  "Trim the video": "Video inkorten",
  "trim|From": "Vanaf",
  "Enter start time in hh:mm:ss format if you want to clip the beginning of the video. For example, if you want to start the video 20 minutes into the live stream, enter \"00:20:00\"": "Vul een starttijd in (uu:mm:ss) als je het begin van de video wilt wegknippen. Wil je de video bijvoorbeeld 20 minuten na de start van de livestream laten beginnen, vul dan \"00:20:00\" in",
  "MOV or MP4 video. Up to 200 GB.": "MOV- of MP4-video. Tot 200 GB.",
  "upload status|converted": "geconverteerd",
  "upload status|converting": "wordt geconverteerd",
  "upload status|waiting to convert": "wacht op conversie",
  "This video was already uploaded for this event (status: {status}).": "Deze video is al geüpload voor dit evenement (status: {status}).",
  "{part} of {total} {unit}": "{part} van {total} {unit}",
  "Resuming — {sizes} were already uploaded": "Hervatten — {sizes} was al geüpload",
  "Starting over — nothing had finished uploading yet": "Opnieuw beginnen — er was nog niets volledig geüpload",
  "under a minute left": "nog minder dan een minuut",
  "about {count} min left": {
    "one": "nog ongeveer {count} min",
    "other": "nog ongeveer {count} min"
  },
  "about {count} h {minutes} min left": {
    "one": "nog ongeveer {count} u {minutes} min",
    "other": "nog ongeveer {count} u {minutes} min"
  },
  "about {count} h left": {
    "one": "nog ongeveer {count} u",
    "other": "nog ongeveer {count} u"
  },
  "Pause": "Pauzeren",
  "Resume": "Hervatten",
  "Upload again": "Opnieuw uploaden",
  "upload card|View event page": "Evenementpagina bekijken",
  "You can leave this page meanwhile.": "Je kunt deze pagina intussen verlaten.",
  "Processing starting soon": "Verwerking begint zo",
  "We're finishing other videos first. You can leave this page meanwhile.": "We maken eerst andere video's af. Je kunt deze pagina intussen verlaten.",
  "Waiting for processing…": "Wachten op verwerking…",
  "Preparing your video…": "Je video wordt voorbereid…",
  "Publishing to your event page…": "Publiceren op je evenementpagina…",
  "Almost done.": "Bijna klaar.",
  "Still processing…": "Nog bezig met verwerken…",
  "Processing video… {percent}%": "Video verwerken… {percent}%",
  "Uploading video": "Video uploaden",
  "Waiting for network…": "Wachten op netwerk…",
  "Starting the upload…": "Upload starten…",
  "Calculating time left…": "Resterende tijd berekenen…",
  "Paused": "Gepauzeerd",
  "The upload continues where it stopped.": "De upload gaat verder waar hij gestopt is.",
  "Finishing upload…": "Upload afronden…",
  "Putting the video together.": "De video wordt samengevoegd.",
  "{size} uploaded": "{size} geüpload",
  "Your video is ready": "Je video is klaar",
  "It's on your event page now.": "De video staat nu op je evenementpagina.",
  "Upload interrupted": "Upload onderbroken",
  "Already uploaded": "Al geüpload",
  "Upload cancelled": "Upload geannuleerd",
  "This upload was cancelled. The event's video hasn't changed.": "Deze upload is geannuleerd. De video van het evenement is niet gewijzigd.",
  "Could not open the video. Please try again.": "De video kon niet worden geopend. Probeer het opnieuw.",
  "Discard this unfinished upload?": "Deze onvoltooide upload weggooien?",
  "The part already uploaded will be deleted.": "Het deel dat al is geüpload, wordt verwijderd.",
  "Discard upload": "Upload weggooien",
  "upload|Keep it": "Bewaren",
  "It replaces the event's video.": "Deze vervangt de video van het evenement.",
  "It goes at the end of the event's video.": "Deze komt aan het eind van de video van het evenement.",
  "It goes at the beginning of the event's video.": "Deze komt aan het begin van de video van het evenement.",
  "It goes between the event's video fragments.": "Deze komt tussen de videofragmenten van het evenement.",
  "Try again, or upload it again.": "Probeer het opnieuw of upload de video opnieuw.",
  "Please upload it again.": "Upload de video opnieuw.",
  "We couldn't process your video": "We konden je video niet verwerken",
  "“{filename}” was uploaded but couldn't be converted.": "“{filename}” is geüpload, maar kon niet worden geconverteerd.",
  "The video was uploaded but couldn't be converted.": "De video is geüpload, maar kon niet worden geconverteerd.",
  "If it keeps happening, contact support.": "Blijft dit gebeuren? Neem dan contact op met support.",
  "Trying again…": "Opnieuw proberen…",
  "Try again →": "Opnieuw proberen →",
  "Contact support →": "Contact opnemen met support →",
  "notice|Dismiss": "Sluiten",
  "Unfinished upload": "Onvoltooide upload",
  "“{filename}” ({size}), {percent}% uploaded.": "“{filename}” ({size}), {percent}% geüpload.",
  "Choose the same file to continue where the upload stopped.": "Kies hetzelfde bestand om verder te gaan waar de upload stopte.",
  "Resume upload →": "Upload hervatten →",
  "Discard": "Weggooien",
  "Photo Library": "Fotobibliotheek",
  "Files": "Bestanden",
  "Choose a video": "Kies een video",
  "Your event is live. Upload after the stream ends.": "Je evenement is live. Upload na afloop van de stream.",
  "This event no longer exists.": "Dit evenement bestaat niet meer.",
  "You don't have access to upload video to this event.": "Je hebt geen toegang om video's naar dit evenement te uploaden.",
  "This upload has expired. Please choose the file again.": "Deze upload is verlopen. Kies het bestand opnieuw.",
  "This upload has already finished or was cancelled.": "Deze upload is al voltooid of geannuleerd.",
  "Some parts of the video haven't uploaded yet.": "Sommige delen van de video zijn nog niet geüpload.",
  "The uploaded video doesn't match the file. Please upload it again.": "De geüploade video komt niet overeen met het bestand. Upload de video opnieuw.",
  "This video was already uploaded for this event.": "Deze video is al geüpload voor dit evenement.",
  "Too many uploads are in progress. Finish or cancel one, then try again.": "Er lopen te veel uploads. Rond er een af of annuleer er een en probeer het dan opnieuw.",
  "This file is too large. Videos can be up to 200 GB.": "Dit bestand is te groot. Video's mogen maximaal 200 GB zijn.",
  "This file is empty. Please choose another video.": "Dit bestand is leeg. Kies een andere video.",
  "Please choose a video file (MP4 or MOV).": "Kies een videobestand (MP4 of MOV).",
  "This upload couldn't be started. Please choose the file again.": "Deze upload kon niet worden gestart. Kies het bestand opnieuw.",
  "Video upload is temporarily unavailable. Please try again later.": "Video's uploaden is tijdelijk niet mogelijk. Probeer het later opnieuw.",
  "Something went wrong on our side. Please try again.": "Er is aan onze kant iets misgegaan. Probeer het opnieuw.",
  "This video can't be converted again. Please upload it again.": "Deze video kan niet opnieuw worden geconverteerd. Upload de video opnieuw.",
  "This upload is no longer available. Please choose the file again.": "Deze upload is niet meer beschikbaar. Kies het bestand opnieuw.",
  "This upload can't continue. Please choose the file again.": "Deze upload kan niet verder. Kies het bestand opnieuw.",
  "This file can't be uploaded. Please choose another video.": "Dit bestand kan niet worden geüpload. Kies een andere video.",
  "Too many uploads at once. Please wait a moment and try again.": "Te veel uploads tegelijk. Wacht even en probeer het opnieuw.",
  "Could not reach the upload service. Check your internet connection and try again.": "De uploaddienst is niet bereikbaar. Controleer je internetverbinding en probeer het opnieuw.",
  "The upload was interrupted. Check your internet connection and try again.": "De upload is onderbroken. Controleer je internetverbinding en probeer het opnieuw.",
  "This upload doesn't match the file. Please choose the file again.": "Deze upload komt niet overeen met het bestand. Kies het bestand opnieuw.",
  "Could not finish the upload. Please try again.": "De upload kon niet worden voltooid. Probeer het opnieuw.",
  "Could not read the video file. Please choose it again.": "Het videobestand kon niet worden gelezen. Kies het opnieuw.",
  "Another upload for this event is still in progress.": "Er loopt nog een andere upload voor dit evenement.",
  "There's no upload to continue.": "Er is geen upload om te hervatten.",
  "Could not start the conversion again. Please try again later.": "De conversie kon niet opnieuw worden gestart. Probeer het later opnieuw.",
  "Choose the file again to continue the upload.": "Kies het bestand opnieuw om verder te gaan met de upload.",
  "That's a different file. Choose “{name}” to continue this upload.": "Dat is een ander bestand. Kies “{name}” om verder te gaan met deze upload.",
  "Choose a video file.": "Kies een videobestand.",
  "There isn't enough free space on this device to continue the upload. Free up some space, then try again.": "Er is niet genoeg vrije ruimte op dit apparaat om verder te gaan met de upload. Maak wat ruimte vrij en probeer het dan opnieuw.",
  "This upload was cancelled.": "Deze upload is geannuleerd.",
  "Upload failed": "Uploaden mislukt",
  "Upload File": "Bestand uploaden",
  "File uploaded": "Bestand geüpload",
  "Guest list saved to Files": "Gastenlijst opgeslagen in Bestanden",
  "Downloads > {filename}": "Downloads > {filename}",
  "Files > On my iPhone > EventLive > {filename}": "Bestanden > Op mijn iPhone > EventLive > {filename}",
  "Could not save the file.": "Het bestand kon niet worden opgeslagen.",
  "Please try again on web": "Probeer het opnieuw in de webversie"
}
